<!-- 
  © 2025 Ananda Kumar. All rights reserved.
  Unauthorized copying of this file, via any medium, is strictly prohibited.
  Part of the Kinvyt.com Angular application.
-->
<div class="calendar-container text-center px-3 g-0 w-80 w-md-100">
    <!-- Month & Year Heading -->
    <h2 class="mb-3">{{ month }} {{ year }}</h2>

    <!-- Calendar Table -->
    <div class="calendar-wrapper  w-80 w-md-100">
        <table class="table table-bordered  w-80 w-md-100">
            <thead>
                <tr>
                    <th *ngFor="let day of days">{{ day }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let week of calendar">
                    <td *ngFor="let date of week" [ngClass]="{'highlight': date === 28}"
                        (click)="date === 28 ? triggerConfetti() : null">

                        <div *ngIf="date">
                            <!-- Highlighted Date with Plus Icon -->
                            <div class="highlight-content" *ngIf="date === 28" (click)="cellClicked()">
                                <!-- <span class="plus-icon d-none d-lg-flex" data-bs-toggle="tooltip"
                                    data-bs-placement="bottom" title="Add to Calendar">
                                    +
                                </span> -->
                                <div class="date-number">{{ date }}</div>
                            </div>

                            <!-- Regular Date -->
                            <span *ngIf="date !== 28">{{ date }}</span>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Calendar Buttons Section -->
    <div class="container mt-4">
        <!-- Google Calendar Button -->
        <div class="row justify-content-center mb-2">
            <div class="col-10">
                <a [href]="googleCalendarLink" target="_blank" class="btn btn-google w-100">
                    <i class="fab fa-google"></i> Add to Google Calendar
                </a>
            </div>
        </div>

        <!-- ICS File (Apple) Button -->
        <div class="row justify-content-center mb-2">
            <div class="col-10">
                <a [href]="icsFileLink" download class="btn btn-ics w-100">
                    <i class="fas fa-download"></i> Download ICS File
                </a>
            </div>
        </div>

        <!-- Outlook Calendar Button -->
        <div class="row justify-content-center mb-2">
            <div class="col-10">
                <a [href]="outlookCalendarLink" target="_blank" class="btn btn-outlook w-100">
                    <i class="fas fa-calendar-alt"></i> Add to Outlook Calendar
                </a>
            </div>
        </div>
    </div>

</div>